<!-- ORGANISM: DrawerHeader.vue -->

<script setup lang="ts">
import DrawerHeaderExpanded from "../molecules/DrawerHeaderExpanded.vue";
import DrawerHeaderRail from "../molecules/DrawerHeaderRail.vue";

//
// Composables
//
const { drawerRailMode } = useDrawer();

//
// Props
//
defineProps<{
  appLogoExpandedMode?: string | null;
  appLogoRailMode?: string | null;
  appName?: string;
  userName?: string;
  userEmail?: string;
}>();
</script>

<template>
  <drawer-header-expanded
    v-if="!drawerRailMode"
    :app-logo-expanded-mode="appLogoExpandedMode"
    :app-name="appName"
    :user-name="userName"
    :user-email="userEmail"
  />

  <drawer-header-rail v-else :app-logo-rail-mode="appLogoRailMode" />
</template>
